import { EulerStateManager } from "../EulerStateManager";
import { BaseState } from "../States/BaseState";

class UpdatePlaying extends BaseState<EulerStateManager> {
  public id = "UpdatePlaying"; // A unique identifier for the state
  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  public onEnter(stateManager: EulerStateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterUpdatePlayingState();

    this.stateManager.changeState(stateManager.eulerEventPlayingState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { UpdatePlaying };
